import { useRouter } from 'next/router';

import { Box, Heading, Label, Popover, TriggerButton } from '@zillow/constellation-10';

import {
  ContentStyledComponent,
  ParagraphStyledComponentConstructor,
  TextStyledComponent,
  TextStyledComponentConstructor,
} from '@zg-rentals/backend-styled-components';

import { useGetListingRecommendations } from '../../hooks/queries/properties';

import PremiumTag from '../PremiumTag';

type Props = {
  label: string;
  recommendationType: string;
};

const RecommendationLabel = ({ label, recommendationType }: Props) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { recommendationsData } = useGetListingRecommendations({ listingAlias });
  const recommendation = recommendationsData?.recommendations?.find((rec) => rec.type === recommendationType);

  if (!recommendation?.learnMore) {
    return <Label>{label}</Label>;
  }

  const title = TextStyledComponentConstructor(recommendation.learnMore.title ?? { text: 'Recommendation' });
  const content = (recommendation.learnMore.content ?? []).map((c) => ParagraphStyledComponentConstructor(c));

  return (
    <Box css={{ display: 'flex', alignItems: 'center', gap: 'tighter', marginBlockEnd: 'tightest' }}>
      <Label>{label}</Label>
      <Popover
        header={
          <Box css={{ display: 'flex', alignItems: 'baseline', gap: 'tight' }}>
            <Heading level={6}>
              <TextStyledComponent styledComponentContent={{ ...title, type: 'text' }} />
            </Heading>
            {recommendation.isPremium && <PremiumTag size="sm" />}
          </Box>
        }
        body={<ContentStyledComponent title={{ ...title, text: '' }} content={content} />}
        trigger={<TriggerButton aria-label={`About ${label.toLowerCase()}`} />}
      />
    </Box>
  );
};

export default RecommendationLabel;
